import { Grid } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';

export const FieldsContainer = styled(Grid)(({ theme }) => ({
  boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.15)',
  borderRadius: '1rem',
  padding: '1.5rem',
}));
